import React, { useEffect, useRef, useState } from 'react'
import Header from '../sharedFiles/header/header'
import Footer from '../sharedFiles/footer/footer'
import { Button, TextField } from '@mui/material'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./crm.css";
import Greeter from './greeter';
import Commonmodal from './commonModal';
import { useSelector } from 'react-redux';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useNavigate } from 'react-router-dom';
// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';

const CRM = () => {
    const crmPostData = useSelector((state) => state.item.CRMPostData);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        WalkINID: '',
        WalkInType: '',
        PhoneNo: "",
        Reference :'',
        LeadLevel : '',
        AssignExecutive :'',
        customerCategory: '',
        Segment:[],
        CustomerProfile:'',
        SiteType:'',
        CurrentWorkStatus:'',
        ExpectedComplationOfWork:'',
        ItemsChecked:[],
        EstimatedValue:'',
        RequrimentType:'',
        SiteVist:'', 
        Address:''
    });

    useEffect(() => {
        if (crmPostData) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            ...crmPostData,
          }));
        }
      }, [crmPostData]);
    const sliderRef = useRef(null);

    const handleBackNav = () => {
      navigate("/DashBoard")
  }
  return (
    <>
    <Header />
    <div className='customerCreation'>
        <div className='dashImage'></div>
        <div className='dashGradient'></div>
        <div className='CrmGradient'></div>
        <div className="slider-container ">
        <div className='topCustomerCreation'>
                    <button onClick={handleBackNav} className="backIcondiv">
                        <ArrowCircleLeftIcon />
                        <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">
                            Dashboard
                        </p>
                    </button>
                </div>
            {/* <Slider {...settings} ref={sliderRef}> */}
                <Greeter 
                formData ={formData}
                setFormData = {setFormData}
                />
        </div>
    </div>
    <Footer />
</>
  )
}

export default CRM